import { render, staticRenderFns } from "./TableMetadataHeaderMenu.vue?vue&type=template&id=a60e8b88&scoped=true&"
import script from "./TableMetadataHeaderMenu.vue?vue&type=script&lang=js&"
export * from "./TableMetadataHeaderMenu.vue?vue&type=script&lang=js&"
import style0 from "./TableMetadataHeaderMenu.vue?vue&type=style&index=0&id=a60e8b88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a60e8b88",
  null
  
)

export default component.exports